import { useMemo } from "react";
import { useData } from "@/context/DataContext";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Bell, CheckCheck } from "lucide-react";

function formatWhen(iso) {
  const d = new Date(iso);
  return d.toLocaleString("it-IT", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function NotificationsBell() {
  const { notifications, markNotifRead, markAllNotifRead } = useData();
  const unread = useMemo(() => notifications.filter((n) => !n.read).length, [notifications]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="notifications-bell"
          className="relative p-2 rounded-full hover:bg-white/5 transition-colors text-zinc-300 hover:text-white"
          aria-label="Notifiche"
        >
          <Bell size={17} />
          {unread > 0 && (
            <span
              data-testid="notifications-badge"
              className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full text-[10px] font-bold flex items-center justify-center text-white tp-brand-gradient shadow-lg shadow-fuchsia-600/40"
            >
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="tp-glass-strong border-white/10 text-white w-[340px] max-h-[70vh] overflow-hidden p-0"
      >
        <div className="flex items-center justify-between px-3 py-2.5 border-b border-white/5">
          <DropdownMenuLabel className="text-white text-sm p-0">Notifiche</DropdownMenuLabel>
          {unread > 0 && (
            <button
              data-testid="mark-all-read"
              onClick={markAllNotifRead}
              className="text-[11px] text-zinc-400 hover:text-white inline-flex items-center gap-1"
            >
              <CheckCheck size={12} /> Segna tutte
            </button>
          )}
        </div>
        <div className="max-h-[60vh] overflow-y-auto">
          {notifications.length === 0 ? (
            <div className="px-4 py-8 text-center text-sm text-zinc-500 italic">
              Nessuna notifica.
            </div>
          ) : (
            notifications.map((n) => (
              <button
                key={n.id}
                onClick={() => !n.read && markNotifRead(n.id)}
                data-testid={`notification-${n.id}`}
                className={`w-full text-left px-3 py-2.5 border-b border-white/5 last:border-0 hover:bg-white/5 transition-colors ${
                  !n.read ? "bg-white/[0.02]" : ""
                }`}
              >
                <div className="flex items-start gap-2">
                  {!n.read && (
                    <span className="mt-1.5 h-2 w-2 rounded-full tp-brand-gradient shrink-0" />
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="text-sm text-white leading-snug">{n.message}</div>
                    <div className="text-[10px] uppercase tracking-widest text-zinc-500 mt-1">
                      {formatWhen(n.created_at)}
                    </div>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
        <DropdownMenuSeparator className="bg-white/10 m-0" />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
